// @ts-nocheck
/* eslint-disable */
export const allDoneIcon = {
  data: `<svg viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="17.4548" y="10.4543" width="24.5455" height="24.5455" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.5 29.5455H12V5H36.5455V7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 4"/><path d="M24.1487 23.4591L28.5295 26.9118L35.8636 19.3191" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'all-done' as const,
};
